import { faCheck } from '@fortawesome/pro-regular-svg-icons/faCheck';
import { faTimes } from '@fortawesome/pro-regular-svg-icons/faTimes';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';

export default ({value, disabled, onChange}) => (
    <span
        onClick={(e) => {
            if (!disabled) {
                onChange(!value, e)
            }
        }}
        role="checkbox" tabIndex="0" aria-checked="false"
        className={
            'relative inline-block shrink-0 h-6 w-11 ' +
            'rounded-full border-2 border-transparent ' +
            'cursor-pointer transition-colors ease-in-out ' +
            'duration-200 focus:outline-none focus:shadow-outline ' +
            `${value ? 'bg-app-blue-light' : 'bg-gray-500'}` +
            `${!value ? ' opacity-50' : ''}
        ${disabled ? 'opacity-50 cursor-not-allowed' : ''} `
        }>
      <span
          aria-hidden="true"
          className={
              'translate-x-0 relative inline-block h-5 w-5 ' +
              'rounded-full bg-white shadow transform ' +
              'transition ease-in-out duration-200 ' +
              `${value ? 'translate-x-5' : 'translate-x-0'} `
          }>
        <span
            className={
                'ease-in duration-200 absolute ' +
                'inset-0 h-full w-full flex items-center ' +
                'justify-center transition-opacity ' +
                `${value ?
                    'opacity-0' : 'opacity-100'}`
            }>
          <FontAwesomeIcon
              icon={faTimes}
              className={
                  'h-3 w-3 text-gray-400'
              }/>
        </span>
        <span
            className={
                'ease-out duration-100 absolute ' +
                'inset-0 h-full w-full flex items-center ' +
                'justify-center transition-opacity ' +
                `${!value ?
                    'opacity-0' : 'opacity-100'}`
            }>
          <FontAwesomeIcon
              icon={faCheck}
              className={
                  'h-3 w-3 text-gray-500'
              }/>
        </span>
      </span>
    </span>
);

